// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-container[data-v-2e42ab6a] {\n  padding: 20px 20px 10px 20px;\n  border-radius: 12px;\n  margin-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
